/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1FeedbackFeedbackidLangsId200,
  GetApiV1FeedbackFeedbackidLangsId401,
  GetApiV1FeedbackFeedbackidLangsId404,
  GetApiV1FeedbackFeedbackidLangsId500,
  GetApiV1FeedbackFeedbackidLangsIdPathParams,
  GetApiV1FeedbackFeedbackidLangsIdQueryResponse,
} from "../../types/feedbackIdiomasController/GetApiV1FeedbackFeedbackidLangsId.ts";
import { feedbackLangViewModelSchema } from "../feedbackLangViewModelSchema.ts";

export const getApiV1FeedbackFeedbackidLangsIdPathParamsSchema = z.object({
  feedbackId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1FeedbackFeedbackidLangsId200Schema = z.lazy(
  () => feedbackLangViewModelSchema,
) as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1FeedbackFeedbackidLangsId401Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1FeedbackFeedbackidLangsId404Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1FeedbackFeedbackidLangsId500Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsId500>;

export const getApiV1FeedbackFeedbackidLangsIdQueryResponseSchema = z.lazy(
  () => getApiV1FeedbackFeedbackidLangsId200Schema,
) as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsIdQueryResponse>;
